import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { IApplicationState } from './app.model';
import {
  SelectMenuItem,
  SetBreadcrumbsInfo,
  ToggleMobileMenu,
  ToggleSidebarMenu,
  ToggleSubMenu
} from './app.actions';
import { MenuItem } from '@app/core/models';
import { BaseItem } from '@app/shared/models';

const APP_STATE_TOKEN = new StateToken<IApplicationState>('application_state');

@State<IApplicationState>({
  name: APP_STATE_TOKEN,
  defaults: {
    submenuOpened: false,
    selectedMenuItem: null,
    isOpenSidebarMenu: false,
    isOpenMobileMenu: false,
    breadcrumbsInfo: null
  }
})
@Injectable()
export class ApplicationState {
  constructor() {}

  @Selector()
  static submenuOpened(state: IApplicationState): boolean {
    return state.submenuOpened;
  }

  @Selector()
  static selectedMenuItem(state: IApplicationState): MenuItem | null {
    return state.selectedMenuItem;
  }

  @Selector()
  static isOpenSidebarMenu(state: IApplicationState): boolean {
    return state.isOpenSidebarMenu;
  }

  @Selector()
  static isOpenMobileMenu(state: IApplicationState): boolean {
    return state.isOpenMobileMenu;
  }

  @Selector()
  static breadcrumbsInfo(state: IApplicationState): BaseItem[] | null {
    return state.breadcrumbsInfo;
  }

  @Action(ToggleSubMenu)
  toggleSubMenu(ctx: StateContext<IApplicationState>) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      submenuOpened: !state.submenuOpened
    });
  }

  @Action(SelectMenuItem)
  selectMenuItem(ctx: StateContext<IApplicationState>, action: SelectMenuItem) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      selectedMenuItem: action.menuItem,
      submenuOpened: action.isOpenMenu
    });
  }

  @Action(ToggleSidebarMenu)
  toggleSidebarMenu(
    ctx: StateContext<IApplicationState>,
    action: ToggleSidebarMenu
  ) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      isOpenSidebarMenu: action.isOpenMenu
    });
  }

  @Action(ToggleMobileMenu)
  toggleMobileMenu(
    ctx: StateContext<IApplicationState>,
    action: ToggleMobileMenu
  ) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      isOpenMobileMenu: action.isOpenMobileMenu
    });
  }

  @Action(SetBreadcrumbsInfo)
  setBreadcrumbsInfo(
    ctx: StateContext<IApplicationState>,
    action: SetBreadcrumbsInfo
  ) {
    const state = ctx.getState();
    const currentInfo = state.breadcrumbsInfo || [];

    if (action.payload === null) {
      const updatedInfo = null;
      ctx.patchState({ breadcrumbsInfo: updatedInfo });
      return;
    }

    if (Array.isArray(action.payload)) {
      ctx.patchState({ breadcrumbsInfo: action.payload });
      return;
    }

    ctx.patchState({ breadcrumbsInfo: [...currentInfo, action.payload] });
  }
}
